import { render } from "./ReportSummary.vue?vue&type=template&id=6c3b7ecb&ts=true"
import script from "./ReportSummary.vue?vue&type=script&lang=ts"
export * from "./ReportSummary.vue?vue&type=script&lang=ts"

import "./ReportSummary.vue?vue&type=style&index=0&id=6c3b7ecb&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__